var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('DocumentosVentaVue',{attrs:{"desdePendientes":Number(1),"periodoSelect":_vm.periodoSelect}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }